import { postPublicChatBot } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getCouncilInformation = async (payload) => {
  const builder = new UrlBuilder(`/chatbot/get-council-data`);
  try {
    const response = await postPublicChatBot(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getConversation = async (payload) => {
  const builder = new UrlBuilder(`/chatbot/use-council-chatbot`);
  try {
    const response = await postPublicChatBot(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const saveConversation = async (payload) => {
  const builder = new UrlBuilder(`/chatbot/save-conversation`);
  try {
    const response = await postPublicChatBot(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getConversationReport = async (payload) => {
  const builder = new UrlBuilder(`/chatbot/get-conversation`);
  try {
    const response = await postPublicChatBot(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getAddressList = async (payload) => {
  const builder = new UrlBuilder(`/council/moreton-bay/get-addresses`);
  try {
    const response = await postPublicChatBot(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getAddressDetails = async (payload) => {
  const builder = new UrlBuilder(`/council/moreton-bay/get-property-details`);
  try {
    const response = await postPublicChatBot(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const sendContactUsMessage = async (payload) => {
  const builder = new UrlBuilder(`/contact-us/submit`);
  try {
    const response = await postPublicChatBot(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
